import { render, staticRenderFns } from "./ProyekEmptyIcon.vue?vue&type=template&id=33ea5283"
import script from "./ProyekEmptyIcon.vue?vue&type=script&lang=js"
export * from "./ProyekEmptyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports